import React from 'react';
import {Box} from '@mui/material';
import {StyledGrid} from 'presentation/components';
import {AppointmentCardSkeleton} from 'presentation/modules/myAppointments/ui/components/AppointmentCardSkeleton';
import {useMediaQueries} from 'presentation/pages';

export function AppointmentsHistoryLoading() {
	const {isTablet, isMobile} = useMediaQueries();

	return (
		<Box p={isMobile ? 2 : 4}>
			<StyledGrid.Root>
				{Array.from({length: isTablet ? 1 : 2}).map((_, index) => (
					<StyledGrid.Item key={`skeleton${String(index)}`} sm={12} md={12} lg={6}>
						<AppointmentCardSkeleton />
					</StyledGrid.Item>
				))}
			</StyledGrid.Root>
		</Box>
	);
}
